import { BetslipUtilChannels } from "../dependencies";
import { InternalMsgRouter, ExternalMsgRouter } from "../routers";
import { LibConfig } from "../config";
/**
 * @class
 * @implements {IBsUtil}
 * @classdesc Mediates communication with Betslip
 */
export class BsUtil {
    constructor(retriever, parser) {
        this.betslip = LibConfig.betslip;
        this.retriever = retriever;
        this.parser = parser;
        this.internalMsgRouter = new InternalMsgRouter(LibConfig.internalMsgBus);
        this.internalMsgRouter.attachListeners(this.onMessageReceivedInternal, this);
        this.internalMsgRouter.attachBetslipListeners(this.onMessageReceivedFromBetslip, this);
        if (LibConfig.externalBroadcastEnabled) {
            this.externalMsgRouter = new ExternalMsgRouter(LibConfig.externalMsgBus);
            this.externalMsgRouter.attachListeners(this.onMessageReceivedExternal, this);
        }
    }
    /**
     * @method getInstance
     * @description Get BSUtil instance
     */
    static getInstance() {
        return BsUtil.instance;
    }
    /**
     * @method add_items
     * @description Handler for BetslipUtilChannels.listen.commands.add_items message
     * @param {BsUtilAddItemsMessage} data Received data
     */
    add_items(data) {
        this.selectionAdded(data);
        this.processMessage(data, this.betslip.addSelection.bind(this.betslip));
    }
    /**
    * @method remove_items
    * @description Handler for BetslipUtilChannels.listen.commands.remove_items message
    * @param {BsUtilRemoveItemsMessage} data Received data
    */
    remove_items(data) {
        this.selectionRemoved(data);
        this.processMessage(data, this.betslip.removeSelection.bind(this.betslip));
    }
    /**
    * @method get_status
    * @description Handler for BetslipUtilChannels.listen.commands.get_status message
    */
    get_status() {
        this.getBetslipStatus(this.betslip.getSelections());
    }
    /**
    * @method clear_slip
    * @description Handler for BetslipUtilChannels.listen.commands.clear_slip message
    */
    clear_slip() {
        this.betslip.clearAll();
    }
    /**
    * @method selectionAdded
    * @description Handler for InternalMessageBusChannels.legacy.betslip.items.add message
    * @param {BsUtilAddItemsMessage} data Received data
    */
    selectionAdded(data) {
        this.internalMsgRouter.sendMessage(BetslipUtilChannels.Broadcast.Items.added, data);
        this.externalMsgRouter && this.externalMsgRouter.sendMessage(BetslipUtilChannels.Broadcast.Items.added, data);
    }
    /**
    * @method selectionRemoved
    * @description Handler for InternalMessageBusChannels.legacy.betslip.items.remove message
    * @param {BsUtilRemoveItemsMessage} data Received data
    */
    selectionRemoved(data) {
        this.internalMsgRouter.sendMessage(BetslipUtilChannels.Broadcast.Items.removed, data);
        this.externalMsgRouter && this.externalMsgRouter.sendMessage(BetslipUtilChannels.Broadcast.Items.removed, data);
    }
    /**
     * @method getBetslipStatus
     * @description Send BetslipUtilChannels.Broadcast.Status message
     * @param {BsUtilStatusMessage} data Betslip status message
     */
    getBetslipStatus(data) {
        this.internalMsgRouter.sendMessage(BetslipUtilChannels.Broadcast.Status, data);
        this.externalMsgRouter && this.externalMsgRouter.sendMessage(BetslipUtilChannels.Broadcast.Status, data);
    }
    /**
    * @method onMessageReceivedInternal
    * @description Process messages from internal msg bus and execute corresponding handler method
    * @param {BsUtilInternalMsgBusMessage<BsUtilItemsMessage>} msg Received message
    */
    onMessageReceivedInternal(msg) {
        const handler = this.internalMsgRouter.listeners[`${msg.channel}.${msg.subChannel.join(".")}`];
        this[handler] && this[handler](...msg.data);
    }
    /**
     * @method onMessageReceivedFromBetslip
     * @description Process messages from internal msg bus for FullBetSlip and execute corresponding handler method
     * @param {BsUtilInternalMsgBusMessage<BsUtilItemsMessage>} msg Received message
     */
    onMessageReceivedFromBetslip(msg) {
        const handler = this.internalMsgRouter.betslipListeners[`${msg.channel}.${msg.subChannel.join(".")}`];
        this[handler] && this[handler](...msg.data);
    }
    /**
     * @method onMessageReceivedExternal
     * @description Process messages from external msg bus and execute corresponding handler method
     * @param {string} handler Handler method
     * @param {BsUtilItemsMessage} msg Received message
     */
    onMessageReceivedExternal(handler, msg) {
        this[handler] && this[handler](Object.assign({}, msg));
    }
    /**
     * @method processMessage
     * @description Load data from BFF
     * @param {BsUtilItemsMessage} data
     * @param {Function} handler
     */
    processMessage(data, handler) {
        if (!data.items || !data.items.length) {
            return;
        }
        return this.retriever.loadData(data.items, this.onSuccessCb.bind(this, handler), this.onErrorCb);
    }
    /**
     * @method onErrorCb
     * @description Proccess errors
     * @param {Error} error
     */
    onErrorCb(error) {
        console.error(error);
        // TODO: Send status msg with error
    }
    /**
     * @method onSuccessCb
     * @description Add selections to betslip
     * @param {Function} betslipHandler Betslip handler to execute
     * @param {BsUtilItem[]} betslipData Received data from BFF
     */
    onSuccessCb(betslipHandler, betslipData) {
        betslipData.forEach((bsItem) => betslipHandler(this.parser.getLegacySelectionData(bsItem.event, bsItem.market, bsItem.selection)));
    }
}
//# sourceMappingURL=util.js.map